// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { useContext } from "react";

const useHasDocuments = (product?: ProductModel): boolean => {
    const productContext = useContext(ProductContext);
    const { documents } = product || productContext.product || {};

    return Boolean(documents?.length);
};

export default useHasDocuments;
